import Actions from 'actions';

const initialState = Object.freeze({});

function create(state = initialState, action) {
  switch (action.type) {
    case Actions.NEWSLETTER_SIGNUP_REQUEST:
      return initialState;
    case Actions.NEWSLETTER_SIGNUP_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.NEWSLETTER_SIGNUP_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default create;
